export const ONBOARDING_ID_PLAYER_SETTINGS_PODCAST = 'highlight-player-settings';
export const ONBOARDING_ID_UPLOAD_BUTTON = 'highlight-upload-button';
export const ONBOARDING_ID_FILE_VIEW_OPTIONS = 'highlight-file-view-options';
export const ONBOARDING_ID_UPLOAD_PROGRESS = "highlight-upload-progress";
export const ONBOARDING_ID_UNLOCK_SPACE = 'highlight-unlock-space';
export const ONBOARDING_ID_ACCOUNT_SETTINGS = 'highlight-account-settings';
export const ONBOARDING_ID_DRAG_DROP = 'highlight-drag-drop';
export const ONBOARDING_ID_CHATBOT = 'highlight-chatbot';
export const EXIT_FULLSCREEN_VIDEO_FROM_ACTIVE_SLIDESHOW = 'highlight-toggle-gallery-slideshow';